import { Injectable } from "@angular/core";
import { Observable, of, shareReplay, finalize, tap, catchError, map, throwError } from "rxjs";
import { LoaderService } from "src/app/shared/services/loader.service";
import { D2cApiService } from "./d2c-api.service";
import { D2cStorageService } from "./d2c-storage.service";
import { D2cResponseHandlerService } from "./d2c-response-handler.service";
import { AlternateMobileNumber } from "../d2c.interface";

@Injectable({ providedIn: "root" })
export class D2cService {
    private inflightStageRequest$: Observable<any> | null = null;
    showShimmer = false;

    constructor(
        private api: D2cApiService,
        public storage: D2cStorageService,
        private loader: LoaderService,
        private responseHandler: D2cResponseHandlerService
    ) {}

    /** 🔹 Get latest cached stage */
    getLatestStageData(): any {
        return this.storage.get();
    }

    /** 🔹 [Moved] getCibilScore() now called from EntryD2cComponent directly */
    getCibilScore(): Observable<any> {
        if (this.inflightStageRequest$) return this.inflightStageRequest$;

        this.inflightStageRequest$ = this.api.getStage().pipe(
            tap((res) => this.responseHandler.handleResponse(res)),
            finalize(() => {
                this.inflightStageRequest$ = null;
            }),
            shareReplay(1)
        );

        return this.inflightStageRequest$;
    }

    /** ✅ Submit OTP (simple + safe) */
    submitOtp(payload: any): Observable<any> {
        return this.api.submitOtp(payload).pipe(
            map((res) => {
                this.responseHandler.handleResponse(res);
            }),
            catchError((err) => {
                this.responseHandler.handleError(err);
                return throwError(() => err);
            })
        );
    }

    /** 🔹 Submit Alternate Number */
    submitAlterNumber(payload: AlternateMobileNumber): Observable<any> {
        this.loader.show();
        return this.api.submitAltNumber(payload).pipe(
            map((res) => this.responseHandler.handleResponse(res)),
            catchError((err) => {
                this.responseHandler.handleError(err);
                return of(err);
            }),
            finalize(() => this.loader.hide())
        );
    }

    /** 🔹 Get new CIBIL report */
    getNewCibil(): Observable<any> {
        this.loader.show();
        return this.api.getNewCibil().pipe(
            tap((res) => this.responseHandler.handleResponse(res, true)),
            finalize(() => this.loader.hide())
        );
    }

    /** 🔹 Get web report */
    getWebReport(): Observable<any> {
        return this.api.getWebReport().pipe(
            map((res) => {
                return res;
            }),
            catchError((err) => of(err))
        );
    }
}
